import './HeroBanner.scss';
import backIcon from '../../assets/images/back-icon.png';
import { usePressTransition } from '../../hooks/usePressTransition';

interface BannerProps {
    title: string;
    titleLogoSrc?: string;
    desc: string;
    mainLogoSrc?: string;
    showBackButton?: boolean;
    onBackClick?: () => void;
}

const BACK_BUTTON_KEY = 'back';

export const HeroBanner = ({ title, titleLogoSrc, desc, mainLogoSrc, showBackButton, onBackClick }: BannerProps) => {
    const { isPressed, triggerPress } = usePressTransition<string>();

    const handleBackClick = () => {
        if (!onBackClick) return;
        triggerPress(BACK_BUTTON_KEY, onBackClick);
    };

    const handleBackKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleBackClick();
        }
    };

    return (
        <div className="hero-banner">
            {showBackButton && (
                <button
                    className={`hero-banner-back-button${isPressed(BACK_BUTTON_KEY) ? ' hero-banner-back-button--pressed' : ''}`}
                    onClick={handleBackClick}
                    onKeyDown={handleBackKeyDown}
                    aria-label="Back to Panviva Pulse main screen"
                    type="button"
                >
                    <img src={backIcon} alt="" className="back-icon" aria-hidden="true" />
                    <span className="back-text">BACK</span>
                </button>
            )}
            <div className="hero-banner-content">
                <h2 className="hero-banner-title">
                    {title}
                    {titleLogoSrc && <img src={titleLogoSrc} alt={`${title} logo`} />}
                </h2>
                <p className="hero-banner-desc">{desc}</p>
            </div>
            {mainLogoSrc && <img src={mainLogoSrc} alt={`${title} main logo`} />}
        </div>
    );
}